// @flow

import React from 'react';

type WheelTooltipProps = {
  entityLabel: PropTypes.string.isRequired,
  fieldSubtitle: PropTypes.string.isRequired,
};

const WheelTooltip = ({
  entityLabel,
  fieldSubtitle,
}: WheelTooltipProps): React.Element<any> =>
  (<div className="tooltip tooltip--title tooltip--title--top center center--horizontally">
    <span className="tooltip__title h4 h4--small theme--white">
      {entityLabel}
    </span>
    <span className="tooltip__description h3 h3--small">
      {fieldSubtitle}
    </span>
  </div>);

export default WheelTooltip;



// WEBPACK FOOTER //
// ./screens/App/components/WheelTooltip/index.js